import React, { useState, useEffect } from "react";
import moment from "moment";
import { Calendar, momentLocalizer } from "react-big-calendar";
import axios from "axios";
import { baseurladdress } from "../baseurl"
import "react-big-calendar/lib/css/react-big-calendar.css";
import { Modal, ModalFooter, Button } from "react-bootstrap";
import Topnavbar from "../dashboard/topnavbar";
import Sidennav from "../dashboard/sidenavbar";
import Swal from 'sweetalert2';

const localizer = momentLocalizer(moment);

const HolidayPage = () => {
    const accessstaffid = localStorage.getItem("staffid");
    const token = localStorage.getItem("token");
    const [events, setEvents] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [formData, setFormData] = useState({
        title: "",
        description: "",
        date: "",
    });

    const fetchHolidays = async () => {
        try {
            const response = await axios.get(`${baseurladdress}getholidays`, {
                headers: { Authorization: `Bearer ${token}` },
            });

            const holidayEvents = (response.data.response || []).map((event) => ({
                title: event.title,
                start: new Date(event.start),
                end: new Date(event.end),
                allDay: true,
            }));

            setEvents(holidayEvents);
        } catch (error) {
            console.error("Error fetching holidays:", error);
        }
    };

    useEffect(() => {
        fetchHolidays();
    }, []);


    const handleAddHoliday = () => {
        if (formData.title && formData.date) {
            const newEvent = {
                title: formData.title,
                description: formData.description,
                date: formData.date,
                staffid: accessstaffid,
            };

            fetch(`${baseurladdress}addholidayy`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(newEvent),
            })
                .then(res => res.json())
                .then(result => {
                    if (result.status === "success") {
                        Swal.fire({
                            icon: 'success',
                            title: 'Holiday added successfully',
                            showConfirmButton: false,
                            timer: 1500
                        });
                        setFormData({ title: "", description: "", date: "" });
                        setShowModal(false);
                        fetchHolidays();

                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Failed to save holiday',
                            text: result.message || 'An error occurred.',
                        });
                    }
                })
                .catch(err => {
                    console.error("Error adding holiday:", err);
                    Swal.fire({
                        icon: 'error',
                        title: 'Something went wrong!',
                        text: err.message || 'Unable to connect to server.',
                    });
                });
        }
    };


    return (
        <>
            <Topnavbar />
            <Sidennav />

            <div className="content-wrap" style={{ display: 'flex', flexDirection: 'column' }}>
                <div className="container mt-4">
                    <h3 className="d-flex justify-content-between align-items-center">
                        Holidays
                        <Button variant="success" onClick={() => setShowModal(true)}>
                            + Add Holiday
                        </Button>
                    </h3>

                    <div style={{ height: "80vh", marginTop: "20px" }}>
                        <Calendar
                            localizer={localizer}
                            events={events}
                            startAccessor="start"
                            endAccessor="end"
                            views={["month"]}
                            defaultView="month"
                            style={{ height: "100%" }}
                            popup
                            components={{
                                event: ({ event }) => <span>{event.title}</span>,
                            }}
                        />
                    </div>
                </div>
            </div>

            <Modal className="modal-size md modal-top-center" show={showModal} style={{ display: "flex" }}>
                <Modal.Header>
                    <h5>Add Holiday</h5>
                    <span
                        aria-hidden="true"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                            setShowModal(false);
                        }}
                    >
                        ×
                    </span>
                </Modal.Header>
                <Modal.Body className="css">
                    <form>
                        <div>
                            <h6>Holiday Name</h6>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Enter holiday"
                                value={formData.title}
                                onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                            />
                        </div>
                        <div className="mt-3">
                            <h6>Description</h6>
                            <textarea
                                className="form-control"
                                style={{ height: "100px" }}
                                placeholder="description"
                                value={formData.description}
                                onChange={(e) =>
                                    setFormData({ ...formData, description: e.target.value })
                                }
                            ></textarea>
                        </div>
                        <div className="mt-3">
                            <h6>Date</h6>
                            <input
                                type="date"
                                className="form-control"
                                placeholder="Select date"
                                value={formData.date}
                                onChange={(e) => setFormData({ ...formData, date: e.target.value })}
                            />
                        </div>
                    </form>
                </Modal.Body>
                <ModalFooter>
                    <div className="row w-100">
                        <div className="col-auto ml-auto">
                            <button type="button" className="btn btn-primary ml-2" onClick={handleAddHoliday}>
                                Save
                            </button>
                        </div>
                    </div>
                </ModalFooter>
            </Modal>

        </>

    );
};

export default HolidayPage;


